// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yL7V","colBig":"styles_colBig__3Iqn-","colSmall":"styles_colSmall__20dfv"};